import { isValidPhoneNumber } from '@shared/utils/contact-helper';
import { TFunction } from 'i18next';
import z from 'zod';

export const PreferredContactSchema = (t: TFunction) =>
  z
    .object({
      email: z
        .string()
        .trim()
        .toLowerCase()
        .refine((value) => value === '' || z.string().email().safeParse(value).success, {
          message: t('invalid_email_address'),
        }),
      messagingType: z.string().trim(),
      phoneCall: z
        .string()
        .trim()
        .refine((val) => val === '' || isValidPhoneNumber(val), {
          message: t('invalid_phone_number'),
        }),

      messaging: z
        .string()
        .trim()
        .refine((val) => val === '' || isValidPhoneNumber(val), {
          message: t('invalid_phone_number'),
        }),
      emailEnabled: z.boolean(),
      messagingEnabled: z.boolean(),
      phoneCallEnabled: z.boolean(),
      contactMethods: z.boolean().optional(),
      timeRange: z.tuple([z.string(), z.string()]).nullable(),
    })
    .superRefine((data, ctx) => {
      const anySelected = data.emailEnabled || data.messagingEnabled || data.phoneCallEnabled;

      if (!anySelected) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('please_select_at_least_one_contact_method'),
          path: ['contactMethods'],
        });
      }

      if (data.emailEnabled && !data.email) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('email_is_required'),
          path: ['email'],
        });
      }

      if (data.messagingEnabled) {
        if (!data.messaging) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('messaging_number_is_required'),
            path: ['messaging'],
          });
        }
      }

      if (data.phoneCallEnabled && !data.phoneCall) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('phone_number_is_required'),
          path: ['phoneCall'],
        });
      }

      if (anySelected && (!data.timeRange || !data.timeRange[0] || !data.timeRange[1])) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('please_select_a_time_range'),
          path: ['timeRange'],
        });
      }
    });
